import { render } from "./ModalWindowBase.vue?vue&type=template&id=e8d95222&scoped=true"
import script from "./ModalWindowBase.vue?vue&type=script&lang=js"
export * from "./ModalWindowBase.vue?vue&type=script&lang=js"

import "./ModalWindowBase.vue?vue&type=style&index=0&id=e8d95222&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e8d95222"

export default script